import IconButton from '@components/v2/ui/IconButton/IconButton';
import Shortcut from '@components/v2/ui/Shortcut/Shortcut';
import Tooltip from '@components/v2/ui/Tooltip/Tooltip';
import { Search } from 'lucide-react';
import LangEnum from '../../lang/LangEnum';
import { ClarityEvents } from '../../lib/clarity/types/clarityEvents.types';
import { withEvent } from '../../lib/clarity/utils/captureEvent.utils';
import { useTranslation } from '../../modules/translation/TranslationContext';
import { useGlobalSearchContext } from './GlobalSearchProvider';

const GlobalSearchTrigger = () => {
  const { open } = useGlobalSearchContext();
  const { translate } = useTranslation();

  return (
    <Tooltip
      tabIndex={-1}
      TooltipContent={translate(LangEnum.GLOBAL_SEARCH)}
      endAdornment={<Shortcut keys={['ctrl', 'k']} />}
    >
      <IconButton
        icon={Search}
        ariaLabel={translate(LangEnum.GLOBAL_SEARCH)}
        testId="global-search-trigger"
        onClick={withEvent(ClarityEvents.GLOBAL_SEARCH_OPENED_BY_TRIGGER, open)}
      />
    </Tooltip>
  );
};

export default GlobalSearchTrigger;
